import React from 'react';
import ToolkitBatchPage from './toolkit/ToolkitBatchPage';
import { sourceRow } from './toolkit/useToolkitBatch';

// Sync › project › Toolkit › AR Account Types.
//
// Ported from the desktop toolkit's OHIP › AR Accounts AC Type: an Opera v5 AR Account Type report (ARDIRECTDET XML)
// sets each existing Opera Cloud AR account's type — the v5 export tends to land everything as one type. Per row
// the server (toolkit ar.js retype-account) reads the account, skips it when the type already matches, and
// otherwise PUTs the new type, through the project's own OPERA Cloud connection. Accounts are only updated, never
// created — run AR Accounts first.

const COLUMNS = [
    { key: 'ACCOUNT_NO', label: 'AR No' },
    { key: 'ACCOUNT_NAME', label: 'Name' },
    { key: 'RESORT', label: 'Resort' },
    { key: 'currentAccountType', label: 'Current type' },
    { key: 'NEW_ACCOUNT_TYPE', label: 'New type' },
    { key: 'cloudAccountId', label: 'Cloud account' },
];

const request = (row) => ({ area: 'ar', op: 'retype-account', args: { account: sourceRow(row, ['currentAccountType', 'cloudAccountId']) } });
const SERVER = { screen: 'ar-account-types', title: 'AR Account Types', keyOf: (row) => row.ACCOUNT_NO };

const ToolkitArAccountTypesPage = () => (
    <ToolkitBatchPage title="AR Account Types"
        subtitle="Set the type of existing Opera Cloud AR accounts from an Opera v5 AR Account Type report (ardirectdet XML). Accounts already of the right type are skipped."
        fileTitle="Opera v5 AR Account Type report" fileLabel="Choose ardirectdet XML"
        kind="ar-account-types" columns={COLUMNS} searchKeys={['ACCOUNT_NO', 'ACCOUNT_NAME', 'RESORT', 'NEW_ACCOUNT_TYPE']}
        exportName="AR_Accounts_Type_Update" request={request} server={SERVER} />
);

export default ToolkitArAccountTypesPage;
